import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconDialogCanceled({
  dialogId,
  targetElementId,
  tabId,
  premiumAvailable,
}) {
  const traits = {
    dialogId,
    tabId,
    premiumAvailable,
    ...getIconDialogCommonTraits(targetElementId),
  };

  trackEvent(events.SELECT_ICON_DIALOG_CANCELED, traits);
}
